import React from 'react';
import { MAP_TYPES_OPTIONS } from 'constants/map-types-options';
import OptionTypeText from 'components/OptionTypes/OptionTypeText';
import OptionTypeCheckbox from 'components/OptionTypes/OptionTypeCheckbox';
import OptionTypeRadio from 'components/OptionTypes/OptionTypeRadio';
import OptionTypeRadioEmailSignature from 'components/OptionTypes/OptionTypeRadioEmailSignature';
import OptionTypeInputNumber from 'components/OptionTypes/OptionTypeInputNumber';
import OptionTypeInputNumberSizes from 'components/OptionTypes/OptionTypeInputNumberSizes';
import OptionTypeInputNumberBanner from 'components/OptionTypes/OptionTypeInputNumberBanner';

export default function ChecklistItemOptionsType(props) {
  const {
    checklistItem: {
      id,
      optionsType,
      optionsCheckedByDefault = [],
      options
    },
    onChange
  } = props;

  const optionsIsNotHidden = options.filter(option => !option.isHidden);

  const onHandleChange = (values) => {
    onChange({id, options: values});
  };

  return (
    <div className="app-checklist-item-options-type">
      {(() => {
        switch (optionsType) {
          case MAP_TYPES_OPTIONS.CheckboxGroup:
            return <OptionTypeCheckbox
              optionsChecked={optionsCheckedByDefault}
              options={optionsIsNotHidden}
              onChange={onHandleChange}
            />;
          case MAP_TYPES_OPTIONS.RadioGroup:
            return <OptionTypeRadio
              optionsChecked={optionsCheckedByDefault}
              options={optionsIsNotHidden}
              onChange={onHandleChange}
            />;
          case MAP_TYPES_OPTIONS.RadioGroupEmailSignature:
            return <OptionTypeRadioEmailSignature
              optionsChecked={optionsCheckedByDefault}
              options={optionsIsNotHidden}
              onChange={onHandleChange}
            />
          case MAP_TYPES_OPTIONS.InputNumber:
            return <OptionTypeInputNumber
              options={optionsIsNotHidden}
              onChange={onHandleChange}
            />
          case MAP_TYPES_OPTIONS.InputNumberSizes:
            return <OptionTypeInputNumberSizes
              options={optionsIsNotHidden}
              onChange={onHandleChange}
            />
          case MAP_TYPES_OPTIONS.InputNumberBanner:
            return <OptionTypeInputNumberBanner
              options={optionsIsNotHidden}
              onChange={onHandleChange}
            />
          case MAP_TYPES_OPTIONS.Text:
            return <OptionTypeText
              options={optionsIsNotHidden}
            />
          default:
            return <>Not found component</>
        }
      })()}
    </div>
  )
}
